import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

// ── Parceiros Comerciais ─────────────────────────────────────────────────────
// A rede de indicação: contadores, designers e consultores. Cadastro em modal,
// filtro por tipo, busca e contatos à mão (📋 copiar + WhatsApp).

function token() { return localStorage.getItem('token'); }

async function apiJson(url, opts = {}) {
  const res = await fetch(url, {
    ...opts,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}`, ...(opts.headers || {}) },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.erro || 'Erro');
  return data;
}

const TIPOS = ['Contador', 'Designer', 'Consultor'];
const TIPO_INFO = {
  Contador:  { icone: '🧮', cor: '#1d4ed8', bg: '#eff6ff', borda: '#bfdbfe' },
  Designer:  { icone: '🎨', cor: '#7c3aed', bg: '#f5f3ff', borda: '#ddd6fe' },
  Consultor: { icone: '💼', cor: '#b45309', bg: '#fffbeb', borda: '#fde68a' },
};
// Categoria criada pelo Vagner (dinâmica) ganha visual neutro
const infoTipo = (t) => TIPO_INFO[t] || { icone: '🏷️', cor: '#374151', bg: '#f3f4f6', borda: '#d1d5db' };
const pluralTipo = (t) => ({ Contador: 'Contadores', Designer: 'Designeres', Consultor: 'Consultores' }[t] || `${t}s`);

const inp = { padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', boxSizing: 'border-box', background: '#fff', height: 26 };
const lbl = { fontSize: 11, fontWeight: 600, color: '#6b7280', display: 'block', marginBottom: 2 };
const modalBase = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 };

function copiarTexto(t) {
  const fallback = () => {
    const el = document.createElement('textarea');
    el.value = t; document.body.appendChild(el); el.select();
    document.execCommand('copy'); document.body.removeChild(el);
  };
  if (navigator.clipboard) navigator.clipboard.writeText(t).catch(fallback);
  else fallback();
}

// ── Modal cadastrar/editar parceiro ──
function ModalParceiro({ parceiro, tipos = TIPOS, onFechar, onSalvo }) {
  const [form, setForm] = useState(parceiro ? { ...parceiro } : {
    nome: '', tipo: '', empresa: '', telefone: '', email: '', cidade_uf: '', instagram: '', observacao: '',
  });
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);
  const setF = (k) => (e) => { setForm(f => ({ ...f, [k]: e.target.value })); setErro(''); };

  async function salvar() {
    if (!form.nome.trim()) return setErro('Informe o nome do parceiro.');
    if (!form.tipo) return setErro('Escolha o tipo.');
    setSalvando(true);
    try {
      if (parceiro) await apiJson(`/parceiros/${parceiro._id}`, { method: 'PUT', body: JSON.stringify(form) });
      else await apiJson('/parceiros', { method: 'POST', body: JSON.stringify(form) });
      onSalvo();
    } catch (e) { setErro(e.message); setSalvando(false); }
  }

  return (
    <div style={modalBase} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 6, width: 520, maxWidth: '95vw', maxHeight: '90vh', overflowY: 'auto', border: '1px solid #c8d0da' }}>
        <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '6px 6px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: '#fff' }}>🤝 {parceiro ? 'Editar parceiro' : 'Novo parceiro comercial'}</span>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>
        <div style={{ padding: '10px 14px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 8, marginBottom: 8 }}>
            <div>
              <label style={lbl}>Nome <span style={{ color: '#dc2626' }}>*</span></label>
              <input value={form.nome} onChange={setF('nome')} placeholder="Ex: João Contador" style={{ ...inp, width: '100%' }} autoFocus />
            </div>
            <div>
              <label style={lbl}>Tipo <span style={{ color: '#dc2626' }}>*</span></label>
              <select value={form.tipo} onChange={setF('tipo')} style={{ ...inp, width: '100%' }}>
                <option value="">Escolha…</option>
                {tipos.map(t => <option key={t} value={t}>{infoTipo(t).icone} {t}</option>)}
              </select>
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
            <div>
              <label style={lbl}>Empresa / Escritório</label>
              <input value={form.empresa} onChange={setF('empresa')} placeholder="Ex: Contabilidade Silva" style={{ ...inp, width: '100%' }} />
            </div>
            <div>
              <label style={lbl}>Cidade – UF</label>
              <input value={form.cidade_uf} onChange={setF('cidade_uf')} placeholder="Ex: Campina Grande – PB" style={{ ...inp, width: '100%' }} />
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, marginBottom: 8 }}>
            <div>
              <label style={lbl}>Telefone / WhatsApp</label>
              <input value={form.telefone} onChange={setF('telefone')} placeholder="Ex: 83 99999-9999" style={{ ...inp, width: '100%' }} />
            </div>
            <div>
              <label style={lbl}>E-mail</label>
              <input value={form.email} onChange={setF('email')} placeholder="email@exemplo.com" style={{ ...inp, width: '100%' }} />
            </div>
            <div>
              <label style={lbl}>Instagram</label>
              <input value={form.instagram} onChange={setF('instagram')} placeholder="@perfil" style={{ ...inp, width: '100%' }} />
            </div>
          </div>
          <label style={lbl}>Observações</label>
          <textarea value={form.observacao} onChange={setF('observacao')} rows={2}
            placeholder="Ex: indica ~2 clientes/mês, comissão combinada, conheci na feira…"
            style={{ ...inp, width: '100%', height: 'auto', resize: 'vertical', fontFamily: 'inherit', marginBottom: 10 }} />
          {erro && <div style={{ color: '#dc2626', fontSize: 12, marginBottom: 8 }}>⚠ {erro}</div>}
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={salvar} disabled={salvando}
              style={{ background: '#0a1628', color: '#fff', padding: '5px 16px', borderRadius: 4, fontSize: 13, fontWeight: 600, border: 'none', cursor: 'pointer', opacity: salvando ? 0.6 : 1 }}>
              {salvando ? 'Salvando…' : parceiro ? 'Salvar' : 'Cadastrar parceiro'}
            </button>
            <button onClick={onFechar} style={{ background: '#f3f4f6', color: '#374151', padding: '5px 14px', borderRadius: 4, fontSize: 13, border: '1px solid #d1d5db', cursor: 'pointer' }}>Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ── Página ──
// 🎯 Oportunidades do parceiro: histórico das indicações + criar nova.
// A oportunidade nasce vinculada (parceiro_id/parceiro_nome), entra no CRM
// como criação de CLOSER com origem parceiro, e alimenta este histórico.
const ETAPA_ROTULO = {
  lead: ['Lead', '#6b7280'], '1contato': ['1º Contato', '#3b82f6'], viabilidade: ['Viabilidade', '#f59e0b'],
  negociacao: ['Negociação', '#8b5cf6'], ganho: ['Ganho', '#16a34a'], perdido: ['Perdido', '#dc2626'],
  'sem-interacao': ['Sem interação', '#9ca3af'],
};

function ModalOpsParceiro({ parceiro, onFechar }) {
  const [ops, setOps] = useState(null);
  const [closers, setClosers] = useState([]);
  const [criando, setCriando] = useState(false);
  const [nome, setNome] = useState('');
  const [tel, setTel] = useState('');
  const [closer, setCloser] = useState('');
  const [obs, setObs] = useState('');
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  const carregarOps = React.useCallback(() => {
    apiJson('/oportunidades').then(todas =>
      setOps(todas.filter(o => o.parceiro_id === parceiro._id))
    ).catch(() => setOps([]));
  }, [parceiro._id]);

  useEffect(() => {
    carregarOps();
    apiJson('/usuarios').then(us => {
      const cs = us.filter(u => (u.cargo || '').toLowerCase().includes('closer') && u.email !== 'clau@preservamarcas.com.br');
      setClosers(cs);
      const eu = cs.find(c => c.nome === localStorage.getItem('nomeUsuario'));
      setCloser(eu ? eu.nome : (cs[0]?.nome || ''));
    }).catch(() => {});
  }, [carregarOps]);

  const navigate = useNavigate();

  async function criar() {
    if (!nome.trim()) return setErro('Informe o nome do indicado.');
    setSalvando(true);
    try {
      const nova = await apiJson('/oportunidades', {
        method: 'POST',
        body: JSON.stringify({
          nome_cliente: nome.trim(), telefone: tel.trim(), closer,
          observacao: `🤝 Indicação do parceiro ${parceiro.nome}${obs.trim() ? ` — ${obs.trim()}` : ''}`,
          parceiro_id: parceiro._id, parceiro_nome: parceiro.nome,
        }),
      });
      setNome(''); setTel(''); setObs(''); setCriando(false); setErro('');
      // Pedido 17/08: criou pelo parceiro → cai direto no CRM com o card aberto
      if (nova?._id) { navigate(`/crm?oportunidade=${nova._id}`); return; }
      carregarOps();
    } catch (e) { setErro(e.message || 'Falha ao criar.'); }
    setSalvando(false);
  }

  const ganhas = (ops || []).filter(o => o.etapa === 'ganho').length;
  return (
    <div style={modalBase} onClick={onFechar}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 6, width: 560, maxWidth: '95vw', maxHeight: '88vh', overflowY: 'auto', border: '1px solid #c8d0da' }}>
        <div style={{ background: '#0a1628', padding: '8px 14px', borderRadius: '6px 6px 0 0', color: '#fff', fontWeight: 700, fontSize: 14, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span>🎯 Oportunidades — {parceiro.nome}</span>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>
        <div style={{ padding: 14 }}>
          {ops === null ? (
            <div style={{ color: '#9ca3af', fontSize: 13 }}>Carregando…</div>
          ) : (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                <div style={{ fontSize: 12.5, color: '#374151' }}>
                  <strong>{ops.length}</strong> indicação(ões){ops.length > 0 && <> · <span style={{ color: '#15803d', fontWeight: 700 }}>{ganhas} ganha(s)</span></>}
                </div>
                {!criando && (
                  <button onClick={() => setCriando(true)}
                    style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 4, padding: '5px 14px', fontSize: 12.5, fontWeight: 600, cursor: 'pointer' }}>
                    + Nova oportunidade
                  </button>
                )}
              </div>

              {criando && (
                <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 6, padding: 12, marginBottom: 12 }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                    <div>
                      <div style={{ fontSize: 11.5, fontWeight: 600, color: '#374151', marginBottom: 3 }}>Nome do indicado *</div>
                      <input value={nome} onChange={e => { setNome(e.target.value); setErro(''); }} style={inp} />
                    </div>
                    <div>
                      <div style={{ fontSize: 11.5, fontWeight: 600, color: '#374151', marginBottom: 3 }}>Telefone</div>
                      <input value={tel} onChange={e => setTel(e.target.value)} placeholder="(83) 99999-9999" style={inp} />
                    </div>
                    <div>
                      <div style={{ fontSize: 11.5, fontWeight: 600, color: '#374151', marginBottom: 3 }}>Closer responsável</div>
                      <select value={closer} onChange={e => setCloser(e.target.value)} style={inp}>
                        {closers.map(c => <option key={c._id} value={c.nome}>{c.nome}</option>)}
                      </select>
                    </div>
                    <div>
                      <div style={{ fontSize: 11.5, fontWeight: 600, color: '#374151', marginBottom: 3 }}>Observação</div>
                      <input value={obs} onChange={e => setObs(e.target.value)} placeholder="Contexto da indicação…" style={inp} />
                    </div>
                  </div>
                  {erro && <div style={{ color: '#dc2626', fontSize: 12, marginTop: 8 }}>⚠ {erro}</div>}
                  <div style={{ display: 'flex', gap: 8, marginTop: 10, justifyContent: 'flex-end' }}>
                    <button onClick={() => { setCriando(false); setErro(''); }}
                      style={{ background: '#fff', color: '#374151', border: '1px solid #d1d5db', borderRadius: 4, padding: '5px 12px', fontSize: 12.5, cursor: 'pointer' }}>Cancelar</button>
                    <button onClick={criar} disabled={salvando}
                      style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 4, padding: '5px 14px', fontSize: 12.5, fontWeight: 600, cursor: 'pointer', opacity: salvando ? 0.6 : 1 }}>
                      {salvando ? 'Criando…' : '🎯 Criar no CRM'}
                    </button>
                  </div>
                </div>
              )}

              {ops.length === 0 && !criando ? (
                <div style={{ background: '#f9fafb', border: '1px dashed #d1d5db', borderRadius: 6, padding: 16, textAlign: 'center', color: '#9ca3af', fontSize: 12.5 }}>
                  Nenhuma indicação deste parceiro ainda.
                </div>
              ) : (
                ops.map(o => {
                  const [rot, cor] = ETAPA_ROTULO[o.etapa] || [o.etapa, '#6b7280'];
                  return (
                    <div key={o._id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, padding: '7px 10px', borderBottom: '1px solid #f1f5f9' }}>
                      <div style={{ minWidth: 0 }}>
                        <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{o.nome_cliente}</div>
                        <div style={{ fontSize: 11, color: '#6b7280' }}>
                          {o.telefone && <>{o.telefone} · </>}Closer: {o.closer || '—'} · {new Date(o.criado_em).toLocaleDateString('pt-BR')}
                        </div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap' }}>
                        <span style={{ color: cor, border: `1px solid ${cor}`, borderRadius: 10, padding: '1px 9px', fontSize: 11, fontWeight: 700 }}>{rot}</span>
                        <button onClick={() => navigate(`/crm?oportunidade=${o._id}`)}
                          title="Abrir esta oportunidade no CRM"
                          style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 4, padding: '3px 10px', fontSize: 11, fontWeight: 700, cursor: 'pointer' }}>
                          CRM →
                        </button>
                      </div>
                    </div>
                  );
                })
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default function Parceiros() {
  const [parceiros, setParceiros] = useState(null);
  const [filtroTipo, setFiltroTipo] = useState('');
  const [busca, setBusca] = useState('');
  const [modal, setModal] = useState(null); // null | {} novo | parceiro editar
  const [modalOps, setModalOps] = useState(null); // parceiro → histórico + nova oportunidade
  const [modalTarefa, setModalTarefa] = useState(null); // parceiro → nova tarefa na Agenda
  const [salvandoTarefa, setSalvandoTarefa] = useState(false);
  const [copiado, setCopiado] = useState(null);

  const [tipos, setTipos] = useState(TIPOS);
  const ehAdmin = localStorage.getItem('nomeUsuario') === 'Vagner Freitas';

  const carregar = useCallback(() => {
    apiJson('/parceiros').then(setParceiros).catch(() => setParceiros([]));
    apiJson('/parceiros/tipos').then(d => { if (Array.isArray(d) && d.length) setTipos(d); }).catch(() => {});
  }, []);
  useEffect(() => { carregar(); }, [carregar]);

  // Nova categoria (só o Vagner) — vale pra todo mundo na hora
  async function novaCategoria() {
    const nome = window.prompt('Nome da nova categoria de parceiro (ex.: Advogado, Despachante):');
    if (!nome || !nome.trim()) return;
    try {
      const r = await apiJson('/parceiros/tipos', { method: 'POST', body: JSON.stringify({ nome: nome.trim() }) });
      if (Array.isArray(r.tipos)) setTipos(r.tipos);
    } catch (e) { window.alert(e.message); }
  }

  const todos = parceiros || [];
  const cont = Object.fromEntries(tipos.map(t => [t, todos.filter(p => p.tipo === t).length]));

  const filtrados = todos.filter(p => {
    if (filtroTipo && p.tipo !== filtroTipo) return false;
    if (busca) {
      const b = busca.toLowerCase();
      const dig = busca.replace(/\D/g, '');
      if (!(p.nome || '').toLowerCase().includes(b) &&
          !(p.empresa || '').toLowerCase().includes(b) &&
          !(p.cidade_uf || '').toLowerCase().includes(b) &&
          !(dig.length >= 4 && (p.telefone || '').replace(/\D/g, '').includes(dig))) return false;
    }
    return true;
  });

  async function excluir(p) {
    if (!window.confirm(`Excluir o parceiro "${p.nome}"? Essa ação não tem volta.`)) return;
    try { await apiJson(`/parceiros/${p._id}`, { method: 'DELETE' }); carregar(); } catch (e) { window.alert(e.message); }
  }

  // 📅 Tarefa do parceiro: cai na Agenda (subagenda comercial) já com o nome
  // dele na descrição — follow-up, visita, cobrança de indicação…
  function abrirTarefa(p) {
    const amanha = new Date(Date.now() + 86400000 - 3 * 3600000).toISOString().slice(0, 10);
    setModalTarefa({
      parceiro: p,
      descricao: `Falar com ${p.nome}`,
      data: amanha, hora: '09:00',
      destinado_a: localStorage.getItem('nomeUsuario') || '',
      lembrar30: false,
    });
  }
  async function salvarTarefaParceiro() {
    const t = modalTarefa;
    if (!t.descricao.trim()) return window.alert('Descreva a tarefa.');
    setSalvandoTarefa(true);
    try {
      const criada = await apiJson('/agenda', {
        method: 'POST',
        body: JSON.stringify({
          descricao: t.descricao.trim(),
          data_agendada: t.hora ? `${t.data}T${t.hora}` : t.data,
          destinado_a: t.destinado_a,
          subagenda: 'comercial',
          // vínculo pelo nome: a Agenda mostra de quem é a tarefa
          cliente_nome: `🤝 ${t.parceiro.nome}`,
          favorita: false, urgente: false, realizado: '',
        }),
      });
      // Aviso no WhatsApp 30min antes (mesmo motor da Agenda e da ficha)
      if (t.lembrar30 && t.hora && criada?._id) {
        const q = new Date(new Date(`${t.data}T${t.hora}`).getTime() - 30 * 60000);
        const p2 = (n) => String(n).padStart(2, '0');
        await apiJson(`/agenda/${criada._id}/lembrete`, {
          method: 'PUT',
          body: JSON.stringify({ lembrete_em: `${q.getFullYear()}-${p2(q.getMonth() + 1)}-${p2(q.getDate())}T${p2(q.getHours())}:${p2(q.getMinutes())}` }),
        }).catch(() => {});
      }
      setModalTarefa(null);
      window.alert(`✅ Tarefa criada na Agenda${t.lembrar30 && t.hora ? ' — com aviso no WhatsApp 30 min antes' : ''}.`);
    } catch (e) { window.alert(e.message); }
    setSalvandoTarefa(false);
  }
  function copiarTel(p) {
    copiarTexto((p.telefone || '').replace(/\D/g, ''));
    setCopiado(p._id);
    setTimeout(() => setCopiado(null), 2000);
  }

  return (
    <div style={{ maxWidth: 960 }}>
      {modal !== null && <ModalParceiro parceiro={modal._id ? modal : null} tipos={tipos}
        onFechar={() => setModal(null)} onSalvo={() => { setModal(null); carregar(); }} />}

      {/* 📅 Nova tarefa do parceiro */}
      {modalTarefa && (
        <div onClick={() => setModalTarefa(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1200, padding: 16 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 440, maxWidth: '95vw', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ background: '#0a1628', padding: '10px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ color: '#fff', fontSize: 14, fontWeight: 700 }}>📅 Nova tarefa</div>
                <div style={{ color: '#94a3b8', fontSize: 11 }}>🤝 {modalTarefa.parceiro.nome} · vai pra sua Agenda (comercial)</div>
              </div>
              <button onClick={() => setModalTarefa(null)} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: 20, cursor: 'pointer', lineHeight: 1 }}>×</button>
            </div>
            <div style={{ padding: 14 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#374151', marginBottom: 4 }}>O que precisa ser feito *</div>
              <textarea rows={2} value={modalTarefa.descricao} onChange={e => setModalTarefa(t => ({ ...t, descricao: e.target.value }))}
                placeholder="Ex.: cobrar as indicações do mês, levar material, almoço…"
                style={{ width: '100%', boxSizing: 'border-box', padding: '7px 9px', border: '1px solid #c8d0da', borderRadius: 6, fontSize: 13.5, fontFamily: 'inherit', resize: 'vertical', marginBottom: 10 }} />
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 100px', gap: 8, marginBottom: 10 }}>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: '#374151', marginBottom: 4 }}>Data</div>
                  <input type="date" value={modalTarefa.data} onChange={e => setModalTarefa(t => ({ ...t, data: e.target.value }))}
                    style={{ width: '100%', boxSizing: 'border-box', padding: '6px 9px', border: '1px solid #c8d0da', borderRadius: 6, fontSize: 13.5 }} />
                </div>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: '#374151', marginBottom: 4 }}>Hora</div>
                  <input type="time" value={modalTarefa.hora} onChange={e => setModalTarefa(t => ({ ...t, hora: e.target.value }))}
                    style={{ width: '100%', boxSizing: 'border-box', padding: '6px 9px', border: '1px solid #c8d0da', borderRadius: 6, fontSize: 13.5 }} />
                </div>
              </div>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#374151', marginBottom: 4 }}>Destinado a</div>
              <input value={modalTarefa.destinado_a} onChange={e => setModalTarefa(t => ({ ...t, destinado_a: e.target.value }))}
                style={{ width: '100%', boxSizing: 'border-box', padding: '6px 9px', border: '1px solid #c8d0da', borderRadius: 6, fontSize: 13.5, marginBottom: 10 }} />
              <button onClick={() => setModalTarefa(t => ({ ...t, lembrar30: !t.lembrar30 }))}
                title="Aviso no seu WhatsApp 30 minutos antes da hora marcada"
                style={{ background: modalTarefa.lembrar30 ? '#eff6ff' : '#fff', color: modalTarefa.lembrar30 ? '#1d4ed8' : '#6b7280', border: `1px solid ${modalTarefa.lembrar30 ? '#bfdbfe' : '#d1d5db'}`, borderRadius: 6, padding: '5px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer', marginBottom: 12 }}>
                {modalTarefa.lembrar30 ? '🔔 Aviso 30min antes' : '🔕 Avisar 30min antes'}
              </button>
              <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                <button onClick={() => setModalTarefa(null)} style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, padding: '7px 14px', fontSize: 13, cursor: 'pointer' }}>Cancelar</button>
                <button onClick={salvarTarefaParceiro} disabled={salvandoTarefa}
                  style={{ background: '#0a1628', color: '#fff', border: 'none', borderRadius: 6, padding: '7px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', opacity: salvandoTarefa ? 0.6 : 1 }}>
                  {salvandoTarefa ? 'Criando…' : 'Criar tarefa'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {modalOps && <ModalOpsParceiro parceiro={modalOps} onFechar={() => setModalOps(null)} />}

      {/* Cabeçalho */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10, flexWrap: 'wrap', gap: 8 }}>
        <div>
          <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628', margin: 0 }}>🤝 Parceiros Comerciais</h1>
          <p style={{ color: '#6b7280', fontSize: 12, margin: '1px 0 0' }}>Contadores, designers e consultores — a rede que indica clientes.</p>
        </div>
        <button onClick={() => setModal({})}
          style={{ background: '#0a1628', color: '#fff', padding: '5px 16px', borderRadius: 4, fontSize: 13, fontWeight: 600, border: 'none', cursor: 'pointer' }}>
          + Novo Parceiro
        </button>
      </div>

      {/* Resumo + filtro por tipo (os chips filtram) */}
      <div style={{ background: '#fff', border: '1px solid #c8d0da', borderRadius: 4, padding: '6px 14px', marginBottom: 8, display: 'flex', gap: 8, fontSize: 13, flexWrap: 'wrap', alignItems: 'center' }}>
        <button onClick={() => setFiltroTipo('')}
          style={{ padding: '2px 10px', borderRadius: 3, fontSize: 12, fontWeight: !filtroTipo ? 700 : 400, border: '1px solid', borderColor: !filtroTipo ? '#0a1628' : '#d1d5db', background: !filtroTipo ? '#0a1628' : '#fff', color: !filtroTipo ? '#fff' : '#374151', cursor: 'pointer' }}>
          Todos ({todos.length})
        </button>
        {tipos.map(t => {
          const info = infoTipo(t);
          const ativo = filtroTipo === t;
          return (
            <button key={t} onClick={() => setFiltroTipo(ativo ? '' : t)}
              style={{ padding: '2px 10px', borderRadius: 3, fontSize: 12, fontWeight: ativo ? 700 : 600, border: `1px solid ${info.borda}`, background: ativo ? info.cor : info.bg, color: ativo ? '#fff' : info.cor, cursor: 'pointer' }}>
              {info.icone} {pluralTipo(t)} ({cont[t]})
            </button>
          );
        })}
        {ehAdmin && (
          <button onClick={novaCategoria} title="Cadastrar nova categoria de parceiro (ex.: Advogado, Despachante)"
            style={{ padding: '2px 10px', borderRadius: 3, fontSize: 12, fontWeight: 600, border: '1px dashed #94a3b8', background: '#fff', color: '#0a1628', cursor: 'pointer' }}>
            ➕ Categoria
          </button>
        )}
        <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar nome, empresa, cidade ou telefone…"
          style={{ ...inp, flex: 1, minWidth: 180, marginLeft: 'auto' }} />
      </div>

      {/* Lista */}
      {!parceiros ? (
        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 4, padding: 20, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>Carregando…</div>
      ) : filtrados.length === 0 ? (
        <div style={{ background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 4, padding: 20, textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
          {todos.length === 0 ? <>Nenhum parceiro ainda — clique em <strong>+ Novo Parceiro</strong> e monte a rede.</> : 'Nenhum parceiro neste filtro.'}
        </div>
      ) : (
        <div style={{ border: '1px solid #c8d0da', borderRadius: 4, overflowX: 'auto' }}>
          <div style={{ background: '#0a1628', display: 'grid', gridTemplateColumns: '1fr 110px 170px 130px 110px 110px', gap: 0, padding: '5px 10px', minWidth: 790 }}>
            {['Parceiro', 'Tipo', 'Contato', 'Cidade', 'Vendedor', 'Ações'].map(h => (
              <span key={h} style={{ fontSize: 11, fontWeight: 700, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{h}</span>
            ))}
          </div>
          {filtrados.map((p, i) => {
            const info = infoTipo(p.tipo);
            const telDig = (p.telefone || '').replace(/\D/g, '');
            return (
              <div key={p._id} style={{
                display: 'grid', gridTemplateColumns: '1fr 110px 170px 130px 110px 110px',
                alignItems: 'center', gap: 0, padding: '6px 10px', minWidth: 790, boxSizing: 'border-box',
                borderBottom: '1px solid #e8eaed', background: i % 2 === 0 ? '#fafafa' : '#fff',
              }}>
                {/* Parceiro */}
                <div style={{ fontSize: 12.5, paddingRight: 8, minWidth: 0 }}>
                  <div style={{ fontWeight: 700, color: '#0a1628', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.nome}</div>
                  {p.empresa && <div style={{ fontSize: 11, color: '#6b7280' }}>{p.empresa}</div>}
                  {p.observacao && <div style={{ fontSize: 11, color: '#9ca3af', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.observacao}</div>}
                </div>

                {/* Tipo */}
                <div>
                  <span style={{ background: info.bg, color: info.cor, border: `1px solid ${info.borda}`, padding: '1px 8px', borderRadius: 3, fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap' }}>
                    {info.icone} {p.tipo}
                  </span>
                </div>

                {/* Contato */}
                <div style={{ fontSize: 12, color: '#374151', minWidth: 0 }}>
                  {p.telefone && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap' }}>
                      📞 {p.telefone}
                      <button onClick={() => copiarTel(p)} title="Copiar número"
                        style={{ background: copiado === p._id ? '#dcfce7' : '#f3f4f6', color: copiado === p._id ? '#15803d' : '#374151', border: '1px solid #d1d5db', borderRadius: 3, padding: '0 4px', fontSize: 10, cursor: 'pointer', lineHeight: '14px' }}>
                        {copiado === p._id ? '✓' : '📋'}
                      </button>
                      {telDig.length >= 10 && (
                        <a href={`https://wa.me/55${telDig}`} target="_blank" rel="noreferrer" title="Abrir WhatsApp"
                          style={{ textDecoration: 'none', fontSize: 12 }}>💬</a>
                      )}
                    </div>
                  )}
                  {p.email && <div style={{ fontSize: 11, color: '#6b7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>✉️ {p.email}</div>}
                  {p.instagram && <div style={{ fontSize: 11, color: '#6b7280' }}>📸 {p.instagram}</div>}
                </div>

                {/* Cidade */}
                <div style={{ fontSize: 12, color: '#6b7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.cidade_uf || '—'}</div>

                {/* Vendedor: quem cadastrou o parceiro é quem atende (pedido 17/08) */}
                <div style={{ fontSize: 12, fontWeight: 600, color: '#0a1628', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                  title={p.criado_por ? `Cadastrado por ${p.criado_por}` : 'Sem registro de quem cadastrou'}>
                  {(p.criado_por || '').trim().split(/\s+/)[0] || '—'}
                </div>

                {/* Ações */}
                <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                  <button onClick={() => setModalOps(p)} title="Oportunidades indicadas por este parceiro"
                    style={{ background: '#f0fdf4', color: '#15803d', padding: '2px 10px', borderRadius: 3, fontSize: 11, border: '1px solid #bbf7d0', cursor: 'pointer', fontWeight: 700 }}>🎯 Oportun.</button>
                  <button onClick={() => abrirTarefa(p)} title="Criar tarefa na Agenda pra este parceiro (follow-up, visita, cobrança de indicação…)"
                    style={{ background: '#eff6ff', color: '#1d4ed8', padding: '2px 10px', borderRadius: 3, fontSize: 11, border: '1px solid #bfdbfe', cursor: 'pointer', fontWeight: 700 }}>📅 Tarefa</button>
                  <button onClick={() => setModal(p)} title="Editar"
                    style={{ background: '#e8edf2', color: '#0a1628', padding: '2px 10px', borderRadius: 3, fontSize: 11, border: 'none', cursor: 'pointer', fontWeight: 600 }}>✏️ Editar</button>
                  <button onClick={() => excluir(p)} title="Excluir este parceiro (pede confirmação)"
                    style={{ background: '#fef2f2', color: '#dc2626', padding: '2px 10px', borderRadius: 3, fontSize: 11, border: '1px solid #fca5a5', cursor: 'pointer', fontWeight: 700 }}>🗑️ Excluir</button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div style={{ fontSize: 10.5, color: '#9ca3af', marginTop: 6 }}>
        🤝 Dica: registre no campo Observações o combinado de comissão e o ritmo de indicações de cada parceiro.
      </div>
    </div>
  );
}
